import { Box, Card, Center, Loader } from "@mantine/core";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import { Suspense } from "react";
import PollComponent from "./PollComponent";

const indexStyles = `
.sides-closed {
    list-style-type: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .sides-closed li {
    color: #333;
    overflow: hidden;
    padding: 8px 12px !important;
    font-size: 13px !important;
    font-weight: 600;
    line-height: 1.5;
    margin: 0 0 5px !important;
    border-radius: 6px;
    justify-content: space-between;
    position: relative;
    background: transparent;
    border-left: 5px solid transparent;
  }
  
  .sides-closed li.quizzed {
    border-left-color: #979797 !important;
  }
  
  .sides-closed li.quizzed .full-bar {
    opacity: 1;
    background: #F6F6F6 !important;
  }
  
  .sides-closed li.quizzed .overlay {
    opacity: 1;
    background: #e7e7e7 !important;
  }
  
  .sides-closed li.quizzed.correct {
    border-left-color: #2AA974 !important;
  }
  
  .sides-closed li.quizzed.correct .full-bar {
    background: #EDFFF8 !important;
  }
  
  .sides-closed li.quizzed.correct .overlay {
    background: #DFF6ED !important;
  }
  
  .sides-closed li.quizzed.correct .vote-icon path {
    fill: #2AA974 !important;
  }
  
  .sides-closed li.quizzed.voted.incorrect {
    border-left-color: #D91414 !important;
  }
  
  .sides-closed li.quizzed.voted.incorrect .full-bar {
    background: #FFF0F0 !important;
  }
  
  .sides-closed li.quizzed.voted.incorrect .overlay {
    background: #FBD1D1 !important;
  }
  
  .sides-closed li.quizzed.voted.incorrect .vote-icon path {
    fill: #D91414 !important;
  }
  
  .sides-closed li:last-child {
    margin-bottom: 0;
  }
  
  .sides-closed li svg {
    width: 16px;
    height: 16px;
    vertical-align: -3px;
  }
  
  .sides-closed li .text {
    position: relative;
    margin-right: 55px;
    z-index: 3;
    display: flex;
    gap: 8px;
    align-items: center;
  }
  
  .sides-closed li .percent {
    top: 50%;
    padding: 0;
    z-index: 3;
    right: 16px;
    font-size: 13px;
    text-align: right;
    margin-top: -10px;
    position: absolute;
  }
  
  .sides-closed li .percent .side-link {
    margin-left: 5px;
  }
  
  .sides-closed li .full-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
  }
  
  .sides-closed li .overlay {
    opacity: 0.1;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
  }
  
  .sides-closed li.winner .overlay {
    background: #C4CED7;
  }
    .sides {
    list-style-type: none !important;
    padding: 0 !important;
    margin: 0 !important;
    }

.sides li {
    list-style-type: none;
    border: 1px solid #43a5f5;
    text-align: center;
    font-size: 13px !important;
    font-family: var(--font-family);
    font-weight: 600;
    line-height: 1.5;
    cursor: pointer;
    padding: 0 !important;
    margin: 0 0 5px !important;
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    &:hover {
      background-color: rgba(96, 164, 233, 0.1);
    }
}

.sides li:before {
    display: none !important;
    content: none !important;
}

.sides li:last-child {
    margin-bottom: 0;
}

.sides li a, .sides li .a {
    color: #000;
    padding: 7px;
    display: block;
    text-decoration: none;
    font-size: 13px !important;
    width: 100%;
    box-sizing: border-box;
}
`;

const DebatePreviewV2 = ({
  thesis,
  isQuestion,
  viewType,
  brandAccount,
  sides,
  hasSideImage,
  index = 1,
}) => {
  return (
    <MantineProvider>
      <style
        dangerouslySetInnerHTML={{
          __html:
            `
            #app-${index} {
              height: 100%;
              display: flex;
              flex-direction: column;
              font-family: open-sans, sans-serif;
            }
            ` + indexStyles,
        }}
      />
      <Card
        shadow="xs"
        mih={220}
        radius={0}
        pos="relative"
        className={viewType === "2" ? "compact-view" : "normal-view"}
        p={0}
        styles={{
          root: {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Suspense
          fallback={
            <Center h={50}>
              <Loader color="black" type="dots" />
            </Center>
          }
        >
          <Box style={{ root: { flex: 1 }, justifyItems: "center" }}>
            <Box mb={16}>
              <PollComponent
                thesis={thesis}
                isQuestion={isQuestion}
                brandAccount={brandAccount}
                hasSideImage={hasSideImage}
                sides={sides}
              ></PollComponent>
            </Box>
          </Box>
        </Suspense>
      </Card>
    </MantineProvider>
  );
};

export default DebatePreviewV2;
